var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 23.3333L19.9999 16.6666L26.6666 23.3333",
    stroke: "#A35BB1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.6666V36.6666",
    stroke: "#A35BB1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 26.6667C35.3334 26.6667 38.3334 23.6667 38.3334 20C38.3334 16.3334 35.3334 13.3334 31.6667 13.3334H29.8334C29.0001 7.66671 24.1667 3.33337 18.3334 3.33337C12.5001 3.33337 7.66674 7.66671 6.83341 13.3334C6.66675 13.8334 6.66675 14.5 6.66675 15C6.66675 16.3334 6.83341 17.5 7.16675 18.6666C6.66675 18.5 6.33341 18.3334 5.83341 18.3334C3.50008 18.3334 1.66675 20.1667 1.66675 22.5C1.66675 24.8334 3.50008 26.6667 5.83341 26.6667H6.66675",
    stroke: "#A35BB1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.93c5d51654881a5d247ef03e6e7da5f4.svg";
export { ForwardRef as ReactComponent };